<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="stockTaking.status === 'recorded'"
          v-can="'stocktaking.update'"
          :command="close"
          :disabled="buttonLoader"
        >
          <i class="el-icon-s-promotion" /> Leltár véglegesítés
        </el-dropdown-item>
        <!--<el-dropdown-item-->
          <!--v-if="stockTaking.status === 'done' && stockTaking.receipt_file"-->
          <!--v-can="'stocktaking.view'"-->
          <!--:command="openReceipt"-->
          <!--:disabled="buttonLoader"-->
        <!--&gt;-->
          <!--<i class="el-icon-printer" /> Bizonylat nyomtatása-->
        <!--</el-dropdown-item>-->
        <el-dropdown-item
          v-can="'stocktaking.update'"
          :command="updateStockTaking"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="stockTaking.status === 'recorded'"
          v-can="'stocktaking.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['stockTaking'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteStockTaking() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('stockTaking/delete', this.stockTaking.id);
          this.$store.dispatch('stockTaking/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      updateStockTaking() {
        this.$router.push('/processes/stock-takings/stock-takings/update/' + this.stockTaking.id);
      },
      async close() {
        this.buttonLoader = true;
        try {
          await axios.post('api/stock-takings/close/' + this.stockTaking.id);
        } catch (e) {
        }
        this.$store.dispatch('stockTaking/fetchAll');
        this.buttonLoader = false;
      },
      openReceipt() {
        if (this.stockTaking.receipt_file && this.stockTaking.receipt_file.path) {
          window.open(this.stockTaking.receipt_file.path);
        }
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteStockTaking();
        })
        .catch(() => {
          this.$router.replace('/processes/stock-takings/stock-takings');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/stock-takings/' + this.stockTaking.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'stock_taking_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
    }
  };
</script>

